import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { EmiDataService } from "app/emi-data.service";

@Injectable()
export class HomeLoanTransferPageResolver implements Resolve<any> {
  constructor(
      private emiData: EmiDataService
  ) {}
  
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any>|Promise<any>|any {
      console.log('HomeLoanTransferPageResolver=>start');
      return this.emiData.getHomeLoanPageDatas('/loan/transfer-home-loan');
  }
}


// WEBPACK FOOTER //
// ./src/app/loan/home-loan-transfer-page/home-loan-transfer-page-resolve.ts